import { NewOrderType, TNewOrderForm } from "@/entities/new-order";
import { Checkbox } from "@/shared/ui/checkbox";
import Hint from "@/shared/ui/hint";
import { Flex, Stack, Text } from "@mantine/core";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { CountryImpressionsBlock } from "./country-impressions-block";
import styles from "./country-item.module.scss";
import { CountryKeywordsTable } from "./country-keywords-table";

type TCountryTableProps = {
  countryIndex: number;
};

export const CountryTableBlock = ({ countryIndex }: TCountryTableProps) => {
  const [autofillChecked, setAutofillChecked] = useState(true);

  const { watch } = useFormContext<TNewOrderForm>();

  const { type } = watch();

  if (type === NewOrderType.review) {
    return null;
  }

  return (
    <Stack>
      <Text p="sm" c="grey">
        Tasks
      </Text>
      {(type === NewOrderType.install ||
        type === NewOrderType.install_with_views) && (
        <CountryImpressionsBlock countryIndex={countryIndex} />
      )}
      <Flex align="center" gap="sm" p="sm">
        <Text fw="bold">Row autofill</Text>
        <Hint popupText="If selected, the values in the cells of each day will repeat the value from the first day for each keyword" />
        <Checkbox
          name={"autofill-" + countryIndex}
          checked={autofillChecked}
          onChange={(event) => setAutofillChecked(event.target.checked)}
        />
      </Flex>
      <div className={styles.tasks__table}>
        <CountryKeywordsTable
          countryIndex={countryIndex}
          autofill={autofillChecked}
        />
      </div>
    </Stack>
  );
};
